import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col bg-gray-lp-1400 p-2 pb-4" }
const _hoisted_2 = { class: "flex md:flex-row flex-col justify-between items-start gap-1" }
const _hoisted_3 = { class: "flex justify-start flex-col" }
const _hoisted_4 = { class: "flex font-semibold text-base text-black-lp-100 items-center" }
const _hoisted_5 = { class: "bubble-content" }
const _hoisted_6 = { class: "font-medium text-xs text-gray-lp-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_CustomerLeaderboardTagFilter = _resolveComponent("CustomerLeaderboardTagFilter")!
  const _component_TableLeaderboard = _resolveComponent("TableLeaderboard")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, {
      class: "p-3 flex-grow flex flex-col min-h-0 gap-y-4",
      rounded: "2xl"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.customerTitle) + " ", 1),
              _createVNode("img", {
                src: require('@/app/ui/assets/svg/ics_o_info_circle_gray.svg'),
                alt: "info-circle",
                class: "ml-1 cursor-pointer",
                onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip($event))),
                onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
              }, null, 40, ["src"]),
              _createVNode(_component_OverlayPanel, {
                ref: "opTooltip",
                class: "bubble-tooltip"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("dashboard.customer.tooltip")), 1)
                ]),
                _: 1
              }, 512)
            ]),
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.lastUpdateAt), 1)
          ]),
          _createVNode(_component_CustomerLeaderboardTagFilter, { onChange: _ctx.onFilterChanged }, null, 8, ["onChange"])
        ]),
        _createVNode(_component_TableLeaderboard, {
          data: _ctx.stateData.customerLeaderboardData,
          hasMore: _ctx.hasMore,
          onLoadMore: _ctx.loadMoreLeaderboard,
          onSort: _ctx.onSort,
          loading: _ctx.stateData.isLoadingCustomerLeaderboard,
          error: _ctx.stateData.errorCustomerLeaderboard,
          accountCurrency: _ctx.accountCurrency
        }, null, 8, ["data", "hasMore", "onLoadMore", "onSort", "loading", "error", "accountCurrency"])
      ]),
      _: 1
    })
  ]))
}